import type { IxdReportPeriodType } from "@/apis/ixd-editor/types";
import { IxdReportChips } from "@/components/common/ixd-report-name";

interface SelectedIxdFileCardProps {
  fileName: string;
  periodYear?: number | null;
  periodType?: IxdReportPeriodType | null;
}

export const SelectedIxdFileCard = ({
  fileName,
  periodYear,
  periodType,
}: SelectedIxdFileCardProps) => (
  <div
    role="status"
    data-selected-ixd-file
    className="w-full min-w-0 shrink-0 border-t border-line-normal pt-3"
  >
    <div className="flex w-full items-center gap-3 overflow-hidden rounded-[8px] bg-background-neutral-normal p-3">
      <span
        aria-hidden
        className="flex size-12 shrink-0 items-center justify-center rounded-[8px] bg-background-base text-label-normal"
      >
        <img
          data-ixd-file-icon
          src="/icons/ixd-file.svg"
          alt=""
          className="size-8"
        />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-1 overflow-hidden">
        <IxdReportChips periodYear={periodYear} periodType={periodType} />
        <span
          data-ixd-file-name
          className="block truncate body-2-normal-medium text-label-normal"
        >
          {fileName}
        </span>
      </span>
    </div>
  </div>
);
